import { makeStyles, tokens } from '@fluentui/react-components';

export const usePanelFieldsStyles = makeStyles({
  container: {
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
  },
  scroller: {
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
  },
  grid: {
    display: 'grid',
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    alignItems: 'start',
    rowGap: '14px',
    columnGap: '14px',
    gridTemplateColumns: 'minmax(0, 1fr)',
  },
  gridSections: {
    rowGap: 0,
  },
  gridCols2: {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  },
  gridCols3: {
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  },
  cell: {
    minWidth: 0,
    maxWidth: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'flex-start',
    '& > *': {
      minWidth: '0',
      width: '100%',
    },
    '& .fui-Field__control': {
      minWidth: 0,
      maxWidth: '100%',
    },
    '& .fui-Input, & .fui-Textarea, & .fui-Dropdown, & .fui-Combobox, & .fui-SpinButton, & .fui-Select, & .fui-DatePicker, & input:not([type="radio"]):not([type="checkbox"]), & textarea':
      {
        width: '100%',
        minWidth: '0 !important',
        maxWidth: '100%',
      },
    '& .fui-Field__label': {
      overflowWrap: 'break-word',
      maxWidth: '100%',
      minWidth: 0,
      marginInline: 0,
    },
  },
  cellFullWidth: {
    gridColumn: '1 / -1',
  },
  cellSection: {
    borderTop: `1px solid ${tokens.colorNeutralStroke2}`,
    '&:first-child': { borderTop: 'none' },
  },
  section: {
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    marginBottom: tokens.spacingVerticalXL,
  },
  headerTitle: {
    display: 'block',
    width: '100%',
    boxSizing: 'border-box',
    fontSize: tokens.fontSizeBase400,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    paddingBottom: tokens.spacingVerticalS,
    marginTop: tokens.spacingVerticalXL,
    marginBottom: tokens.spacingVerticalM,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  sectionTitle: {
    display: 'block',
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    paddingBottom: tokens.spacingVerticalS,
    marginBottom: tokens.spacingVerticalL,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  sectionTitleStrong: {
    display: 'block',
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    paddingBottom: tokens.spacingVerticalS,
    marginBottom: tokens.spacingVerticalL,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
  },
});
